export default __webpack_public_path__ + "static/media/F_Fada.291f632d.mp3";